function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "inbox") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 3697",
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1711"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fillable-area",
    "data-name": "Path 358",
    d: "m17.937 124.919-2.344-5.107a.417.417 0 0 0-.4-.212h-2.007a.424.424 0 0 0 0 .848h1.737l1.947 4.239h-2.386a2.74 2.74 0 0 0-2.512 1.632 1.945 1.945 0 0 1-1.758 1.123H7.786a1.945 1.945 0 0 1-1.758-1.123 2.74 2.74 0 0 0-2.512-1.632H1.172l2.3-4.239h1.34a.424.424 0 0 0 0-.848H3.223a.4.4 0 0 0-.377.191l-2.762 5.128a.256.256 0 0 0-.084.17v5.277a2.211 2.211 0 0 0 2.156 2.162h13.688A2.211 2.211 0 0 0 18 130.365v-5.277a.405.405 0 0 0-.063-.169z",
    transform: "translate(3.001 -111.527)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fillable-area",
    "data-name": "Path 359",
    d: "M147.609 22.263a.463.463 0 0 0 .655.028l.028-.028 3.317-3.341a.488.488 0 0 0-.683-.683l-2.488 2.488v-9.268a.488.488 0 1 0-.976 0v9.267l-2.488-2.488a.488.488 0 0 0-.683.683z",
    transform: "translate(-135.949 -7.971)",
    style: {
      fill: "#fff"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInbox);
export default __webpack_public_path__ + "static/media/inbox.9aef5984e1031d764f32d4c955dd683b.svg";
export { ForwardRef as ReactComponent };